import { render } from "./CustomSqlQuery.vue?vue&type=template&id=0cd86dd2&scoped=true"
import script from "./CustomSqlQuery.vue?vue&type=script&lang=js"
export * from "./CustomSqlQuery.vue?vue&type=script&lang=js"

import "./CustomSqlQuery.vue?vue&type=style&index=0&id=0cd86dd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cd86dd2"]])

export default __exports__